import { render, staticRenderFns } from "./comp-label.vue?vue&type=template&id=4370549b&scoped=true&"
import script from "./comp-label.vue?vue&type=script&lang=js&"
export * from "./comp-label.vue?vue&type=script&lang=js&"
import style0 from "./comp-label.vue?vue&type=style&index=0&id=4370549b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4370549b",
  null
  
)

export default component.exports